// extracted by mini-css-extract-plugin
export var backdropBlur = "_65-0";
export var body = "_65-5";
export var bodyScroll = "_65-6";
export var columnFooter = "_65-7";
export var columnFooterFlush = "_65-8";
export var contentColumn = "_65-4";
export var frame = "_65-3";
export var heroContent = "_65-c";
export var heroOverlay = "_65-b";
export var image = "_65-a";
export var imageWrapper = "_65-9";
export var modal = "_65-1";
export var modalMain = "_65-2";
export var productHeader = "_65-d";
export var productHeaderIcon = "_65-e";
export var productHeaderName = "_65-f";
export var progressIndicator = "_65-g";